import {Component, OnInit, Input, SimpleChanges, OnChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {slideRight, slideUp, anim} from 'src/app/animations';

@Component({
    selector: 'app-drawing-floors',
    templateUrl: './drawing-floors.component.html',
    styleUrls: ['./drawing-floors.component.scss'],
    animations: [
        slideRight, slideUp, anim
    ],
    host: {
        '[@anim]': 'condition'
    }
})
export class DrawingFloorsComponent implements OnInit, OnChanges {
    @Input() public item;
    @Input() public drawingHolderWidth;
    buildUid: string;
    isDescktop: boolean = false;


    constructor(private route: ActivatedRoute) {

        this.buildUid = this.route.snapshot.params.buid;
    }

    ngOnInit(): void {
        this.isDescktop = window.innerWidth > 1200;
        this.drawingHolderWidth;

        console.log(this.drawingHolderWidth);
        console.log(this.item, this.buildUid)
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.item && !changes.item.firstChange) {
            this.ifFloorIdIsFloorNumber(this.item);
        }
    }

    ifFloorIdIsFloorNumber(floorId) {
        const numberString = floorId.toString();
        if (numberString.length < 5) {
            return true;
        } else {
            return false;
        }
    }

}
